import { graphql } from 'react-apollo';

import gql from 'graphql-tag';

import type { Skill } from '@coursera/grpc-types-skills/coursera/proto/skills/v2/skill';
import type {
  GetSkillRequest,
  GetSkillResponse,
} from '@coursera/grpc-types-skills/coursera/proto/skills/v2/skills_api';

type PropsFromCaller = {
  skillId: string;
};

export type PropsFromGetSkillsQuery = {
  skill?: Skill;
  isSkillLoading: boolean;
};

export const SkillDetailsQuery = gql`
  query SkillDetailsQuery($input: GetSkillRequest!) {
    GetSkill(input: $input) @rest(type: "GetSkillResponse", path: "grpc/skills/v2/SkillsAPI/GetSkill", method: "POST") {
      skill
    }
  }
`;

const withSkillDetails = graphql<
  PropsFromCaller,
  { GetSkill: GetSkillResponse },
  { input: GetSkillRequest },
  PropsFromGetSkillsQuery
>(SkillDetailsQuery, {
  options: ({ skillId }) => ({
    variables: {
      input: {
        skillId,
      },
    },
  }),
  props: ({ data }) => {
    if (data?.error) {
      // Caught by error boundary in SkillPageContent
      throw data.error;
    }

    return {
      skill: data?.GetSkill?.skill,
      isSkillLoading: !!data?.loading,
    };
  },
});

export default withSkillDetails;
